class SearchModal extends ModalDrawer {
	constructor() {
		super();

		// The generic slide/overlay/Esc/focus-trap/scroll-lock lifecycle is owned by the
		// nested <modal-drawer> that drawer-shell emits (see search-modal.liquid). This
		// element keeps the search-specific concern: wiring the header search trigger.
		this.setHeaderCartIconAccessibility();

		// Productive #308: the drawer must open empty once a search has been submitted.
		// A submit is a full navigation, so the input no longer prefills from search.terms
		// (search-modal.liquid); this covers the bfcache path, where Back restores the
		// page with the typed query still sitting in the field.
		window.addEventListener("pageshow", (event) => {
			if (event.persisted) this.clearQuery();
		});
	}

	clearQuery() {
		const input = this.querySelector('input[type="search"]');
		if (!input || !input.value) return;
		input.value = "";
		// The search-form family listens for "input"; an empty query tears down any
		// painted results and returns the drawer to its Default state.
		input.dispatchEvent(new Event("input", { bubbles: true }));
	}

	// The live <modal-drawer> panel emitted by drawer-shell inside <search-modal>.
	get modalDrawer() {
		return this.querySelector("modal-drawer");
	}

	setHeaderCartIconAccessibility() {
		const searchTrigger = document.querySelector("#search-icon-open");
		if (!searchTrigger) return;

		searchTrigger.setAttribute("role", "button");
		searchTrigger.setAttribute("aria-haspopup", "dialog");

		searchTrigger.addEventListener("click", (event) => {
			event.preventDefault();
			this.open(searchTrigger);
		});

		searchTrigger.addEventListener("keydown", (event) => {
			if (event.code.toUpperCase() === "SPACE") {
				event.preventDefault();
				this.open(searchTrigger);
			}
		});
	}

	open(triggeredBy) {
		// Desktop dropdown (#7 FAIL 2): position the panel below the REAL rendered
		// header, not the shared --header-height var. That var (set by
		// header.liquid's ResizeObserver) measures .shopify-section-header alone,
		// so it never includes the announcement bar — a sibling section that's
		// only visually part of the chrome before the page scrolls. Reading the
		// header's own getBoundingClientRect().bottom sidesteps that: it's
		// naturally correct in both states (announcement bar in-flow above it
		// pre-scroll, gone once the header goes sticky), and the drawer's own
		// scroll-lock (see modal-drawer.js) freezes page scroll while it's open,
		// so one measurement per open is enough. Scoped to this component via a
		// local custom property — the shared --header-height var is untouched.
		const header = document.querySelector(".shopify-section-header");
		if (header) {
			this.style.setProperty(
				"--search-drawer-top",
				`${header.getBoundingClientRect().bottom}px`
			);
		}

		this.modalDrawer?.open(triggeredBy);

		// The base traps focus to the panel; search additionally lands focus on the
		// search input once the panel has slid in (mirrors Madrid's search-open UX).
		this.modalDrawer?.addEventListener(
			"transitionend",
			() => {
				const focusElement =
					this.querySelector('.header__search input:not([type="hidden"])') ||
					this.querySelector(".search__main") ||
					this.querySelector(".search__close");
				focusElement?.focus();
			},
			{ once: true }
		);
	}

	close() {
		this.modalDrawer?.close();
	}
}

customElements.define("search-modal", SearchModal);
